import { useDevice } from '@/utils/useDevice'
import { LoadingPlugin } from 'tdesign-mobile-vue';

let loadingCount = 0;
let loadingInstance = null;

const { isMobile } = useDevice()

export const showLoading = (msg = '') => {
  if (loadingCount === 0) {
    loadingInstance = LoadingPlugin({
      fullscreen: true,
      attach: 'body',
      text: msg,
      size: '40px',
      layout: 'vertical',
      theme: 'spinner',
    });
  }
  loadingCount++;
};

export const hideLoading = () => {
  if (loadingCount <= 0) return;
  loadingCount--;
  if (loadingCount === 0 && loadingInstance) {
    loadingInstance.hide();
    loadingInstance = null;
  }
};